var map = {
	"./gs/NewUi": 927,
	"./gs/NewUi.js": 927,
	"./gs/OldUi": 928,
	"./gs/OldUi.js": 928,
	"./spireon/SpireonNew": 929,
	"./spireon/SpireonNew.js": 929,
	"./spireon/SpireonOld": 930,
	"./spireon/SpireonOld.js": 930
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 2690;